export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10590.3e3e0a35.jpg";